(function () {
  'use strict';

  if (!/^ar(?:-|$)/i.test((document.documentElement.lang || '').trim())) return;

  function start() {
    var source = document.getElementById('frame-arabic-ui-strings');
    if (!source || source.dataset.frameArabicInitialized === 'true') return;
    var config;
    try { config = JSON.parse(source.textContent); } catch (error) { return; }
    if (!config || !config.strings || typeof config.strings !== 'object') return;

    var strings = Object.create(null);
    Object.keys(config.strings).forEach(function (key) {
      if (typeof config.strings[key] === 'string') {
        strings[normalize(key)] = config.strings[key];
        strings[normalize(key).toLowerCase()] = config.strings[key];
      }
    });
    source.dataset.frameArabicInitialized = 'true';

    var extraUi = '.slick-arrow,.boost-sd__button--close,.boost-sd__filter-tree-vertical-content,' +
      '.boost-sd__button-text-x--clear-input-search-form';
    var candidates = '[id^="swym-"],[class*="swym-"],#notepad-anchor-title,' + extraUi;
    var excluded = 'script,style,code,pre,kbd,samp,noscript,template,select,option,' +
      '[contenteditable]:not([contenteditable="false"]),[translate="no"],[data-frame-arabic-skip],' +
      'a[href*="/products/"],.swym-storefront-layout-grid-item-title,' +
      '.swym-product-title,.swym-product-name,' +
      '[class*="product-title"],[class*="product-name"],[class*="product-link"],' +
      '[class*="image-container"],[class*="imagecontainer"],[class*="product-image"],' +
      '[class*="grid-item-image"],.swym-price,[class*="product-price"],[class*="item-price"],' +
      '[class$="-price"],[class*="-price "],[class*="price-amount"],[class*="price-value"],' +
      '.swym-storefront-layout-grid-item-variant,.swym-product-variant,.swym-product-variants,' +
      '[class*="variant-option-value"],' +
      '[data-product-title],[data-product-price],[data-product-variant]';
    var attributeNames = ['aria-label', 'title', 'placeholder', 'alt'];
    var roots = new Set();
    var pending = new Set();
    var timer = null;
    var watching = false;
    var observerOptions = {
      childList: true, subtree: true, characterData: true, attributes: true,
      attributeFilter: attributeNames
    };

    function normalize(value) { return value.trim().replace(/\s+/g, ' '); }

    function translated(value) {
      var core = normalize(value);
      if (!core) return value;
      if (core === "You have already saved {{itemCount}} of 5 items so you won't be able to save more on this device") return value;
      var next = strings[core] || strings[core.toLowerCase()];
      var match;
      if (typeof next !== 'string' && typeof config.count_label === 'string') {
        match = /^(\d+) items? in wishlist$/i.exec(core);
        if (match) next = config.count_label.replace(/\{count\}/g, match[1]);
      }
      if (typeof next !== 'string' && typeof config.saved_limit === 'string') {
        // Leave {{itemCount}} intact until the native app has interpolated it.
        match = /^You have already saved (\d+) of 5 items so you won't be able to save more on this device$/.exec(core);
        if (match) next = config.saved_limit.replace(/\{count\}/g, match[1]);
      }
      if (typeof next !== 'string' && typeof config.saved_partial === 'string') {
        match = /^You have already saved (\d+) of 5 items you can store on this device\. For unlimited saves and accessing across devices please Log in\.$/.exec(core);
        if (match) next = config.saved_partial.replace(/\{count\}/g, match[1]);
      }
      if (typeof next !== 'string' && typeof config.saved_full === 'string') {
        match = /^You have already saved (\d+) of 5 items on this device, to save more and sync it across devices please Log in\.$/.exec(core);
        if (match) next = config.saved_full.replace(/\{count\}/g, match[1]);
      }
      if (typeof next !== 'string') return value;
      return /^\s*/.exec(value)[0] + next + /\s*$/.exec(value)[0];
    }

    function owns(element) {
      if (!element || element.nodeType !== 1 || /^(HTML|BODY)$/.test(element.tagName)) return false;
      var id = element.getAttribute('id') || '';
      return element.matches(extraUi) || id === 'notepad-anchor-title' || id.indexOf('swym-') === 0 ||
        Array.prototype.some.call(element.classList, function (name) { return name.indexOf('swym-') === 0; });
    }

    function topOwner(node) {
      var element = node.nodeType === 1 ? node : node.parentElement;
      var result = null;
      while (element && element !== document.documentElement) {
        if (owns(element)) result = element;
        element = element.parentElement;
      }
      return result;
    }

    function isExcluded(element) { return !!element.closest(excluded); }

    function walk(root) {
      if (isExcluded(root)) return;
      var stack = [root];
      while (stack.length) {
        var node = stack.pop();
        if (node.nodeType === 3) {
          var value = translated(node.nodeValue);
          if (value !== node.nodeValue) node.nodeValue = value;
          continue;
        }
        if (node.nodeType !== 1 || node.matches(excluded)) continue;
        if (node.matches('button.boost-sd__button-text-x--clear-input-search-form') && node.getAttribute('role') === 'textbox') {
          node.setAttribute('role', 'button');
        }
        if (node.matches('.boost-sd__button--close svg')) node.setAttribute('aria-hidden', 'true');
        attributeNames.forEach(function (name) {
          var value = node.getAttribute(name);
          if (value === null) return;
          var next = translated(value);
          if (next !== value) node.setAttribute(name, next);
        });
        // Keep field values, options and SVG geometry/title children app-owned.
        if (/^(INPUT|TEXTAREA|SVG|MATH|CANVAS)$/.test(node.tagName.toUpperCase())) continue;
        for (var i = node.childNodes.length - 1; i >= 0; i--) stack.push(node.childNodes[i]);
      }
    }

    function register(node) {
      var root = topOwner(node);
      if (!root || !root.isConnected || isExcluded(root)) return;
      roots.forEach(function (other) { if (other !== root && root.contains(other)) roots.delete(other); });
      roots.add(root);
      pending.add(root);
    }

    function discover(node) {
      if (node.nodeType !== 1) return;
      if (topOwner(node)) { register(node); return; }
      node.querySelectorAll(candidates).forEach(function (element) { if (owns(element)) register(element); });
    }

    function watchRoots() {
      roots.forEach(function (root) {
        if (!root.isConnected) roots.delete(root);
        else uiObserver.observe(root, observerOptions);
      });
    }

    function flush() {
      timer = null;
      // Disconnect only while writing, so our own translations cannot loop.
      if (watching) uiObserver.disconnect();
      var work = Array.from(pending);
      pending.clear();
      work.forEach(function (root) {
        if (root.isConnected && !work.some(function (other) { return other !== root && other.contains(root); })) walk(root);
      });
      if (watching) watchRoots();
    }

    function schedule() { if (timer === null) timer = window.setTimeout(flush, 32); }

    var uiObserver = new MutationObserver(function (records) {
      records.forEach(function (record) { register(record.target); });
      if (pending.size) schedule();
    });
    var discoveryObserver = new MutationObserver(function (records) {
      var removed = false;
      records.forEach(function (record) {
        if (record.type === 'attributes') {
          if (owns(record.target)) register(record.target);
          return;
        }
        if (topOwner(record.target)) register(record.target);
        else record.addedNodes.forEach(discover);
        if (record.removedNodes.length) removed = true;
      });
      if (removed) roots.forEach(function (root) {
        if (!root.isConnected) { roots.delete(root); schedule(); }
      });
      if (pending.size) schedule();
    });

    discover(document.body);
    flush();
    watching = true;
    watchRoots();
    // Discover only known app controls globally; content/ARIA observation stays scoped.
    discoveryObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'id'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
